import { useSelector } from 'react-redux';
import { getUserRequiresEmailValidation } from '../../auth/selectors';
import { getCurrentBranch } from '../../branches/selectors';
import { getCurrentProjectId } from '../../project/selectors';

export const useTopbar = () => {
  const projectId = useSelector(getCurrentProjectId);
  const branch = useSelector(getCurrentBranch);
  const userRequiresEmailValidation = useSelector(getUserRequiresEmailValidation);

  return { projectId, branch, userRequiresEmailValidation: Boolean(userRequiresEmailValidation) };
};

export type TopbarHookProps = ReturnType<typeof useTopbar>;
